import { useServerTranslation } from 'hooks/useServerTranslation';

import { z } from 'zod';

export function useTranslatedCustomerLoginSchema() {
    const { t } = useServerTranslation();

    return z.object({
        email: z.string()
            .min(1, { message: t('errors.required.email') })
            .email({ message: t('errors.format.email') }),
        password: z.string().min(8, t('errors.min.password')),
    });
}
